import { Link } from 'react-router-dom';
import { useDocumentMeta } from '../hooks/useDocumentMeta';

export function NotFoundPage() {
  useDocumentMeta({
    title: 'Página no encontrada | Corporación Indemniza',
    description: 'La ruta solicitada no existe en el sitio de Corporación Indemniza.',
    robots: 'noindex,nofollow',
  });

  return (
    <section className="not-found">
      <div className="site-container">
        <p className="eyebrow">404</p>
        <h1>Página no encontrada</h1>
        <p>La ruta solicitada no existe.</p>
        <Link to="/">Volver al inicio</Link>
      </div>
    </section>
  );
}
